import {infiniteCount} from "@/config/Other";

export interface RequiredSampleParticipant {
    sampleType: unknown[];
}

export interface RequiredSampleValidationResult {
    isRequired: boolean;
    isValid: boolean;
    requiredParticipantsCount: number;
    participantsWithPaidSampleCount: number;
    participantsWithoutPaidSample: RequiredSampleParticipant[];
}

export function hasPaidSample(sampleType: unknown[]): boolean {
    return sampleType.length > 0;
}

export function getRequiredSampleValidation({
    participants,
    participantsMin,
    sampleMin,
}: {
    participants: RequiredSampleParticipant[];
    participantsMin: number | null;
    sampleMin: number | null;
}): RequiredSampleValidationResult {
    const isRequired = sampleMin !== null && sampleMin > 0;
    const requiredParticipantsCount = getRequiredParticipantsCount(participants.length, participantsMin);
    const participantsWithoutPaidSample = participants.filter(participant => !hasPaidSample(participant.sampleType));
    const participantsWithPaidSampleCount = participants.length - participantsWithoutPaidSample.length;

    return {
        isRequired,
        isValid: !isRequired || participantsWithPaidSampleCount >= requiredParticipantsCount,
        requiredParticipantsCount,
        participantsWithPaidSampleCount,
        participantsWithoutPaidSample,
    };
}

function getRequiredParticipantsCount(participantsCount: number, participantsMin: number | null): number {
    if (participantsMin === null || participantsMin === infiniteCount) {
        return participantsCount;
    }

    return participantsMin;
}
